import { useI18n } from '../../i18n';
import type { MatchStatus } from '../../lib/wcTypes';

/** Compact match-status pill (LIVE 67' / FT / PICK). Ported from shell.jsx. */
export function StatusBadge({ status, minute }: { status: MatchStatus; minute?: number }) {
  const { t } = useI18n();
  if (status === 'live') {
    return (
      <span class="bc-status bc-status--live">
        <span class="bc-status__dot" />
        {t('game.status.live')} {minute ?? 0}'
      </span>
    );
  }
  if (status === 'done') return <span class="bc-status bc-status--done">{t('game.status.ft')}</span>;
  if (status === 'cancelled')
    return <span class="bc-status bc-status--done">{t('game.status.cancelled')}</span>;
  return <span class="bc-status bc-status--pick">{t('game.status.pick')}</span>;
}
